import { IMediaStateService } from "./model"

export const state: IMediaStateService = {
  progressTimeout: undefined,
  creativeUploadRefreshTimeout: undefined,
  mediaInfoById: {}
}
